<script lang="ts">
    export let image: string | undefined = undefined;
    export let text: string | undefined = undefined;
</script>

{#if image}
    <img class="book-image" src={image} alt="" />
    {#if text}
        <span class="image-headline">{text}</span>
    {/if}
{:else if text}
    <span class="book-text">{text}</span>
{/if}

<style>
    .book-text {
        font-size: 3svh;
        text-align: left;
    }

    .book-image {
        width: 100cqw;
    }

    .image-headline {
        font-size: 4svh;
        text-align: center;
        font-weight: bold;
    }
</style>
